'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gtmSafeRedirect = exports.disambiguateAliases = exports.scrollToTop = exports.errorActionCreator = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.msaByAlias = msaByAlias;
exports.getUserLocation = getUserLocation;
exports.geodetectMsa = geodetectMsa;
exports.userSupportsUnifedSearch = userSupportsUnifedSearch;
exports.promotionValidInMsa = promotionValidInMsa;
exports.venueAliasToId = venueAliasToId;
exports.getUserId = getUserId;
exports.userHasPermission = userHasPermission;

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _GoogleTagManager = require('components/GoogleTagManager/GoogleTagManager');

var _msas = require('constants/msas');

var _extendableError = require('helpers/extendable-error');

var _extendableError2 = _interopRequireDefault(_extendableError);

var _selectors = require('redux/saga/selectors');

var _locale = require('redux/modules/locale');

var _bound = require('redux/saga/entities/bound');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(msaByAlias),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getUserLocation),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(geodetectMsa),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(userSupportsUnifedSearch),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(promotionValidInMsa),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(venueAliasToId),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(getUserId),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(userHasPermission);

var errorActionCreator = exports.errorActionCreator = function errorActionCreator(type, error) {
  if (__SERVER__ && !__TEST__) {
    throw error;
  }
  if (__LOCAL_DEV__ && !__TEST__) {
    console.error(error); // eslint-disable-line no-console
  }
  return {
    type: type,
    error: error
  };
};

function msaByAlias(client, alias) {
  var allMsas, msa;
  return _regenerator2.default.wrap(function msaByAlias$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.msas, [client]);

        case 2:
          allMsas = _context.sent;
          msa = allMsas.filter(function (thisMsa) {
            return thisMsa.alias === alias;
          })[0];

          if (msa) {
            _context.next = 6;
            break;
          }

          throw new _extendableError2.default('Bad MSA alias ' + alias, {
            code: 404,
            httpStatus: 404
          });

        case 6:
          return _context.abrupt('return', msa);

        case 7:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

/* istanbul ignore next */
var scrollToTop = exports.scrollToTop = function scrollToTop() {
  if (__CLIENT__) {
    window.scrollTo(0, 0);
    var contentEl = document.body.querySelector('.body__wrapper');
    if (contentEl) {
      contentEl.scrollTop = 0;
    }
  }
};

function getUserLocation(client) {
  var location;
  return _regenerator2.default.wrap(function getUserLocation$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.select)(_locale.selectUserLocation);

        case 3:
          location = _context2.sent;

          if (!location) {
            _context2.next = 10;
            break;
          }

          _context2.next = 7;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.glsLocation, [client, location.lat, location.lon]);

        case 7:
          _context2.t0 = _context2.sent;
          _context2.next = 11;
          break;

        case 10:
          _context2.t0 = null;

        case 11:
          return _context2.abrupt('return', _context2.t0);

        case 14:
          _context2.prev = 14;
          _context2.t1 = _context2['catch'](0);

          console.error('Got error from GLS API', _context2.t1); // eslint-disable-line no-console
          return _context2.abrupt('return', null);

        case 18:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 14]]);
}

function geodetectMsa(client) {
  var userLocation;
  return _regenerator2.default.wrap(function geodetectMsa$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.call)(getUserLocation, client);

        case 2:
          userLocation = _context3.sent;
          return _context3.abrupt('return', userLocation ? userLocation.msa : null);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function userSupportsUnifedSearch(client) {
  var msa;
  return _regenerator2.default.wrap(function userSupportsUnifedSearch$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.call)(geodetectMsa, client);

        case 2:
          msa = _context4.sent;
          return _context4.abrupt('return', (0, _msas.msaSupportsUnifedSearch)(msa));

        case 4:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

/**
 * Some of our pages receive routes that looked like
 *   /page/<alias> and /page/<msa>/<promo>
 * In the first route, <alias> could be a promo alias,
 * OR an msa alias. This disambiguates them and return
 * an object with the keys `msaAlias` and `promoAlias`.
 */
var disambiguateAliases = exports.disambiguateAliases = function disambiguateAliases(alias, promoAlias) {
  // If we have a promo alias, `alias` must be the MSA alias
  if (promoAlias) {
    return { msaAlias: alias, promoAlias: promoAlias };
  }

  // Otherwise, figure out if `alias` is a valid MSA alias
  if ((0, _msas.msaAliasToId)(alias)) {
    return { msaAlias: alias };
  }

  return { promoAlias: alias };
};

function promotionValidInMsa(client, msaIdentifier, promoAlias) {
  var promo;
  return _regenerator2.default.wrap(function promotionValidInMsa$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.promotionByAlias, [client, promoAlias, msaIdentifier]);

        case 3:
          promo = _context5.sent;
          return _context5.abrupt('return', promo && promo.offers && promo.offers.length > 0);

        case 7:
          _context5.prev = 7;
          _context5.t0 = _context5['catch'](0);
          return _context5.abrupt('return', false);

        case 10:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this, [[0, 7]]);
}

function venueAliasToId(client, alias) {
  var venue;
  return _regenerator2.default.wrap(function venueAliasToId$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.venueByIdV2, [client, alias, { extended: true }]);

        case 2:
          venue = _context6.sent;

          if (!venue) {
            _context6.next = 7;
            break;
          }

          _context6.next = 6;
          return (0, _effects.put)(_bound.venueByIdV2.successAction({ data: venue, key: venue.id }));

        case 6:
          return _context6.abrupt('return', venue.id);

        case 7:
          return _context6.abrupt('return', null);

        case 8:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function getUserId(client) {
  var loggedIn, profile;
  return _regenerator2.default.wrap(function getUserId$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.select)(_selectors.isLoggedIn);

        case 2:
          loggedIn = _context7.sent;

          if (!loggedIn) {
            _context7.next = 8;
            break;
          }

          _context7.next = 6;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 6:
          profile = _context7.sent;
          return _context7.abrupt('return', profile.id);

        case 8:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function userHasPermission(client, permission) {
  var userId, permissions;
  return _regenerator2.default.wrap(function userHasPermission$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.call)(getUserId, client);

        case 2:
          userId = _context8.sent;

          if (!userId) {
            _context8.next = 8;
            break;
          }

          _context8.next = 6;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userPermissions, [client, userId]);

        case 6:
          permissions = _context8.sent;
          return _context8.abrupt('return', !!permissions[permission]);

        case 8:
          return _context8.abrupt('return', false);

        case 9:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

/**
 * Adds a GTM event with a redirect callback, and adds fallbacks in case
 * GTM is not loaded or removed (by an adblocker, for instance).
 *
 * Should be called after tracking calls, but can be safely yielded as the last
 * effect in parallel with tracking events.
 */
var gtmSafeRedirect = exports.gtmSafeRedirect = function gtmSafeRedirect(url) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 750;

  if (__CLIENT__ || __TEST__) {
    // If GTM is not loaded/removed, let's redirect immediately
    // because tags are not firing anyway.
    if (!window.google_tag_manager) {
      window.location.href = url;
      return _promise2.default.resolve();
    }

    var callbackPromise = new _promise2.default(function (resolve) {
      return (0, _GoogleTagManager.trackGoogleTagManagerEvent)({
        event: 'redirect',
        eventCallback: resolve,
        eventTimeout: timeout
      });
    });

    // Fallback timeout in case GTM is not available at this
    // point for some reason.
    var timeoutPromise = new _promise2.default(function (resolve) {
      return setTimeout(resolve, timeout);
    });

    return _promise2.default.race([callbackPromise, timeoutPromise]).then(function () {
      return window.location.href = url;
    });
  }
};